module.exports = __webpack_public_path__ + "assets/img/Super-Obvious-Landing-Page.ab8cb0ac.webp";